// Language options list
export const LANGUAGES = [
  {
    code: "af",
    name: "Afrikaans",
    label: "Afrikaans",
    value: "af",
  },
  {
    code: "sq",
    name: "Albanian",
    label: "Albanian",
    value: "sq",
  },
  {
    code: "am",
    name: "Amharic",
    label: "Amharic",
    value: "am",
  },
  {
    code: "ar",
    name: "Arabic",
    label: "Arabic",
    value: "ar",
  },
  {
    code: "hy",
    name: "Armenian",
    label: "Armenian",
    value: "hy",
  },
  {
    code: "az",
    name: "Azerbaijani",
    label: "Azerbaijani",
    value: "az",
  },
  {
    code: "bn",
    name: "Bengali",
    label: "Bengali",
    value: "bn",
  },
  {
    code: "bs",
    name: "Bosnian",
    label: "Bosnian",
    value: "bs",
  },
  {
    code: "bg",
    name: "Bulgarian",
    label: "Bulgarian",
    value: "bg",
  },
  {
    code: "ca",
    name: "Catalan",
    label: "Catalan",
    value: "ca",
  },
  {
    code: "zh",
    name: "Chinese (Simplified)",
    label: "Chinese (Simplified)",
    value: "zh",
  },
  {
    code: "zh-TW",
    name: "Chinese (Traditional)",
    label: "Chinese (Traditional)",
    value: "zh-TW",
  },
  {
    code: "hr",
    name: "Croatian",
    label: "Croatian",
    value: "hr",
  },
  {
    code: "cs",
    name: "Czech",
    label: "Czech",
    value: "cs",
  },
  {
    code: "da",
    name: "Danish",
    label: "Danish",
    value: "da",
  },
  {
    code: "fa-AF",
    name: "Dari",
    label: "Dari",
    value: "fa-AF",
  },
  {
    code: "nl",
    name: "Dutch",
    label: "Dutch",
    value: "nl",
  },
  {
    code: "en",
    name: "English",
    label: "English",
    value: "en",
  },
  {
    code: "et",
    name: "Estonian",
    label: "Estonian",
    value: "et",
  },
  {
    code: "fa",
    name: "Farsi (Persian)",
    label: "Farsi (Persian)",
    value: "fa",
  },
  {
    code: "tl",
    name: "Filipino, Tagalog",
    label: "Filipino, Tagalog",
    value: "tl",
  },
  {
    code: "fi",
    name: "Finnish",
    label: "Finnish",
    value: "fi",
  },
  {
    code: "fr",
    name: "French",
    label: "French",
    value: "fr",
  },
  {
    code: "fr-CA",
    name: "French (Canada)",
    label: "French (Canada)",
    value: "fr-CA",
  },
  {
    code: "ka",
    name: "Georgian",
    label: "Georgian",
    value: "ka",
  },
  {
    code: "de",
    name: "German",
    label: "German",
    value: "de",
  },
  {
    code: "el",
    name: "Greek",
    label: "Greek",
    value: "el",
  },
  {
    code: "gu",
    name: "Gujarati",
    label: "Gujarati",
    value: "gu",
  },
  {
    code: "ht",
    name: "Haitian Creole",
    label: "Haitian Creole",
    value: "ht",
  },
  {
    code: "ha",
    name: "Hausa",
    label: "Hausa",
    value: "ha",
  },
  {
    code: "he",
    name: "Hebrew",
    label: "Hebrew",
    value: "he",
  },
  {
    code: "hi",
    name: "Hindi",
    label: "Hindi",
    value: "hi",
  },
  {
    code: "hu",
    name: "Hungarian",
    label: "Hungarian",
    value: "hu",
  },
  {
    code: "is",
    name: "Icelandic",
    label: "Icelandic",
    value: "is",
  },
  {
    code: "id",
    name: "Indonesian",
    label: "Indonesian",
    value: "id",
  },
  {
    code: "ga",
    name: "Irish",
    label: "Irish",
    value: "ga",
  },
  {
    code: "it",
    name: "Italian",
    label: "Italian",
    value: "it",
  },
  {
    code: "ja",
    name: "Japanese",
    label: "Japanese",
    value: "ja",
  },
  {
    code: "kn",
    name: "Kannada",
    label: "Kannada",
    value: "kn",
  },
  {
    code: "kk",
    name: "Kazakh",
    label: "Kazakh",
    value: "kk",
  },
  {
    code: "ko",
    name: "Korean",
    label: "Korean",
    value: "ko",
  },
  {
    code: "lv",
    name: "Latvian",
    label: "Latvian",
    value: "lv",
  },
  {
    code: "lt",
    name: "Lithuanian",
    label: "Lithuanian",
    value: "lt",
  },
  {
    code: "mk",
    name: "Macedonian",
    label: "Macedonian",
    value: "mk",
  },
  {
    code: "ms",
    name: "Malay",
    label: "Malay",
    value: "ms",
  },
  {
    code: "ml",
    name: "Malayalam",
    label: "Malayalam",
    value: "ml",
  },
  {
    code: "mt",
    name: "Maltese",
    label: "Maltese",
    value: "mt",
  },
  {
    code: "mr",
    name: "Marathi",
    label: "Marathi",
    value: "mr",
  },
  {
    code: "mn",
    name: "Mongolian",
    label: "Mongolian",
    value: "mn",
  },
  {
    code: "no",
    name: "Norwegian (Bokmål)",
    label: "Norwegian (Bokmål)",
    value: "no",
  },
  {
    code: "ps",
    name: "Pashto",
    label: "Pashto",
    value: "ps",
  },
  {
    code: "pl",
    name: "Polish",
    label: "Polish",
    value: "pl",
  },
  {
    code: "pt",
    name: "Portuguese (Brazil)",
    label: "Portuguese (Brazil)",
    value: "pt",
  },
  {
    code: "pt-PT",
    name: "Portuguese (Portugal)",
    label: "Portuguese (Portugal)",
    value: "pt-PT",
  },
  {
    code: "pa",
    name: "Punjabi",
    label: "Punjabi",
    value: "pa",
  },
  {
    code: "ro",
    name: "Romanian",
    label: "Romanian",
    value: "ro",
  },
  {
    code: "ru",
    name: "Russian",
    label: "Russian",
    value: "ru",
  },
  {
    code: "sr",
    name: "Serbian",
    label: "Serbian",
    value: "sr",
  },
  {
    code: "si",
    name: "Sinhala",
    label: "Sinhala",
    value: "si",
  },
  {
    code: "sk",
    name: "Slovak",
    label: "Slovak",
    value: "sk",
  },
  {
    code: "sl",
    name: "Slovenian",
    label: "Slovenian",
    value: "sl",
  },
  {
    code: "so",
    name: "Somali",
    label: "Somali",
    value: "so",
  },
  {
    code: "es",
    name: "Spanish",
    label: "Spanish",
    value: "es",
  },
  {
    code: "es-MX",
    name: "Spanish (Mexico)",
    label: "Spanish (Mexico)",
    value: "es-MX",
  },
  {
    code: "sw",
    name: "Swahili",
    label: "Swahili",
    value: "sw",
  },
  {
    code: "sv",
    name: "Swedish",
    label: "Swedish",
    value: "sv",
  },
  {
    code: "ta",
    name: "Tamil",
    label: "Tamil",
    value: "ta",
  },
  {
    code: "te",
    name: "Telugu",
    label: "Telugu",
    value: "te",
  },
  {
    code: "th",
    name: "Thai",
    label: "Thai",
    value: "th",
  },
  {
    code: "tr",
    name: "Turkish",
    label: "Turkish",
    value: "tr",
  },
  {
    code: "uk",
    name: "Ukrainian",
    label: "Ukrainian",
    value: "uk",
  },
  {
    code: "ur",
    name: "Urdu",
    label: "Urdu",
    value: "ur",
  },
  {
    code: "uz",
    name: "Uzbek",
    label: "Uzbek",
    value: "uz",
  },
  {
    code: "vi",
    name: "Vietnamese",
    label: "Vietnamese",
    value: "vi",
  },
  {
    code: "cy",
    name: "Welsh",
    label: "Welsh",
    value: "cy",
  },
];

export const getActiveSupportedLanguages = (supportedLanguages = []) => {
  return supportedLanguages?.filter(lang => lang?.isActive) || [];
};
